import { createAction, props } from '@ngrx/store';

//UNIVERSAL
export const loadingStart = createAction(
    '[Market] LOADING_STARTED',
    props<{ data:boolean }>()
);

export const setNav = createAction('[Market] SET_NAV',
  props<{data: any }>()
);

export const setNavSuccess = createAction('[Market] SET_NAV_SUCCESS',
  props<{isNav: any }>()
);

export const getUser = createAction('[Market] GET_USER',
  props<{address: any }>()
);

export const getUserFail = createAction('[Market] GET_USER_FAIL',
  props<{error: any }>()
);

export const getUserSuccess = createAction('[Market] GET_USER_SUCCESS',
  props<{user: any, missionsComp:any, allSkills:any[], pass:any, passrewards:any[], userSeasonRewards:any[], packSigs:any[] }>()
);

export const getSeasons = createAction('[Market] GET_SEASONS',
  props<{data: any }>()
);

export const getSeasonsFail = createAction('[Market] GET_SEASONS_FAIL',
  props<{error: any }>()
);

export const getSeasonsSuccess = createAction('[Market] GET_SEASONS_SUCCESS',
  props<{season: any, pastSeason:any }>()
)

export const getTokens = createAction('[Market] GET_TOKENS',
  props<{address: any }>()
);

export const getTokensFail = createAction('[Market] GET_TOKENS_FAIL',
  props<{error: any }>()
);

export const getTokensSuccess = createAction('[Market] GET_TOKENS_SUCCESS',
  props<{tokens:any, perWallet:any[] }>()
);

export const updateAvatar = createAction('[Market] UPDATE_AVATAR',
  props<{id: any, url:any, address:any, username:any }>()
);

export const updateAvatarFail = createAction('[Market] UPDATE_AVATAR_FAIL',
  props<{error: any }>()
);

export const updateAvatarSuccess = createAction('[Market] UPDATE_AVATAR_SUCCESS',
  props<{status: any }>()
);

export const getAllMissions = createAction('[Market] GET_ALL_MISSIONS',
  props<{data: any }>()
);

export const getAllMissionsFail = createAction('[Market] GET_ALL_MISSIONS_FAIL',
  props<{error: any }>()
);

export const getAllMissionsSuccess = createAction('[Market] GET_ALL_MISSIONS_SUCCESS',
  props<{missions: any[] }>()
);

export const getMyMissions = createAction('[Market] GET_MY_MISSIONS',
  props<{userId: any }>()
);

export const getMyMissionsFail = createAction('[Market] GET_MY_MISSIONS_FAIL',
  props<{error: any }>()
);

export const getMyMissionsSuccess = createAction('[Market] GET_MY_MISSIONS_SUCCESS',
  props<{myMissions: any[] }>()
);

export const deployToMission = createAction('[Market] DEPLOY_TO_MISSIONS',
  props<{userId: any, soldier:any, items:any }>()
);

export const deployToMissionFail = createAction('[Market] DEPLOY_TO_MISSIONS_FAIL',
  props<{error: any }>()
);

export const deployToMissionSuccess = createAction('[Market] DEPLOY_TO_MISSIONS_SUCCESS',
  props<{missions: any[] }>()
);

export const desertMission = createAction('[Market] DESERT_MISSIONS',
  props<{userId: any, mission:any }>()
);

export const desertMissionFail = createAction('[Market] DESERT_MISSIONS_FAIL',
  props<{error: any }>()
);

export const desertMissionSuccess = createAction('[Market] DESERT_MISSIONS_SUCCESS',
  props<{missions: any[] }>()
);

export const claimReward = createAction('[Market] CLAIM_REWARD',
  props<{userId: any, missionId:any }>()
);

export const claimRewardFail = createAction('[Market] CLAIM_REWARD_FAIL',
  props<{error: any }>()
);

export const claimRewardSuccess = createAction('[Market] CLAIM_REWARD_SUCCESS',
  props<{claim: any[] }>()
);

export const claimPassReward = createAction('[Market] CLAIM_PASS_REWARD',
  props<{userId: any,rewardId:any }>()
);

export const claimPassRewardFail = createAction('[Market] CLAIM_PASS_REWARD_FAIL',
  props<{error: any }>()
);

export const claimPassRewardSuccess = createAction('[Market] CLAIM_PASS_REWARD_SUCCESS',
  props<{pass:any, passrewards: any[], myInventory:any[] }>()
);

export const claimSeasonReward = createAction('[Market] CLAIM_SEASON',
  props<{userId: any }>()
);

export const claimSeasonRewardFail = createAction('[Market] CLAIM_SEASON_FAIL',
  props<{error: any }>()
);

export const claimSeasonRewardSuccess = createAction('[Market] CLAIM_SEASON_SUCCESS',
  props<{userSeasonRewards: any[], myInventory:any[] }>()
);

export const login = createAction('[Market] GET_LOGIN',
  props<{provider: any }>()
);

export const loginFail = createAction('[Market] GET_LOGIN_FAIL',
  props<{error: any }>()
);

export const loginSuccess = createAction('[Market] GET_LOGIN_SUCCESS',
  props<{wallet: any, allow:any }>()
);

export const logout = createAction('[Market] GET_LOGOUT',
  props<{data: any }>()
);

export const logoutFail = createAction('[Market] GET_LOGOUT_FAIL',
  props<{error: any }>()
);

export const logoutSuccess = createAction('[Market] GET_LOGOUT_SUCCESS',
  props<{wallet: any }>()
);

export const levels = createAction('[Market] GET_LEVELS',
  props<{data: any }>()
);

export const levelsFail = createAction('[Market] GET_LEVELS_FAIL',
  props<{error: any }>()
);

export const levelsSuccess = createAction('[Market] GET_LEVELS_SUCCESS',
  props<{levels: any }>()
);

  export const getNfts = createAction(
    '[Market] GET_NFTS',
    props<{ data:any }>()
    );
  
  export const getNftsSuccess = createAction(
      '[Market] GET_NFTS_SUCCESS',
      props<{ Nfts: any }>()
    );
  
  export const getNftsFail = createAction(
      '[Market] GET_NFTS_FAIL',
      props<{ error: any }>()
  );

  export const eth = createAction(
    '[Market] ETH',
    props<{ data:any }>()
    );
  
  export const ethSuccess = createAction(
      '[Market] ETH_SUCCESS',
      props<{ eth: any }>()
    );
  
  export const ethFail = createAction(
      '[Market] ETH_FAIL',
      props<{ error: any }>()
  );

  export const purchase = createAction(
    '[Market] PURCHASE',
    props<{ userId:any, listingId:any, address:any, quantity:any, wallet:any, discordId:any }>()
    );
  
  export const purchaseSuccess = createAction(
      '[Market] PURCHASE_SUCCESS',
      props<{ purchase:any }>()
    );
  
  export const purchaseFail = createAction(
      '[Market] PURCHASE_FAIL',
      props<{ error: any }>()
  );

  export const missionsFilter = createAction('[Market] MISSIONS_FILTERS',
  props<{missions:any[], filter:any, userId:any }>()
  );
  
  export const missionsFilterSuccess = createAction('[Market] MISSIONS_FILTERS_SUCCESS',
  props<{missions: any[], filter:any }>()
  );

export const popup = createAction('[Market] POPUP',
props<{pop:any }>()
);

export const popupSuccess = createAction('[Market] POPUP_SUCCESS',
props<{pop: any[] }>()
);

export const timedListing = createAction('[Market] TIMED_LISTING',
props<{showedListings:any, listingIds:any }>()
);

export const timedListingFail = createAction('[Market] TIMED_LISTING_FAIL',
props<{error: any }>()
);

export const timedListingSuccess = createAction('[Market] TIMED_LISTING_SUCCESS',
props<{listing: any[], old:any[] }>()
);

export const setFilter = createAction('[Market] SET_FILTER',
props<{filter:any }>()
);

export const setFilterSuccess = createAction('[Market] SET_FILTER_SUCCESS',
props<{filter:any }>()
);

export const setPage = createAction('[Market] SET_PAGE',
props<{page:any }>()
);

export const setPageSuccess = createAction('[Market] SET_PAGE_SUCCESS',
props<{page:any }>()
);

export const showProfileEdit = createAction('[Market] SHOW_PROFILE_EDIT',
props<{data:any }>()
);

export const showProfileEditSuccess = createAction('[Market] SHOW_PROFILE_EDIT_SUCCESS',
props<{data:any }>()
);

export const inventory = createAction(
  '[Market] INVENTORY',
  props<{ data:any }>()
  );

export const inventorySuccess = createAction(
    '[Market] INVENTORY_SUCCESS',
    props<{ inventory:any }>()
  );

export const inventoryFail = createAction(
    '[Market] INVENTORY_FAIL',
    props<{ error: any }>()
);

export const myinventory = createAction(
  '[Market] MYINVENTORY',
  props<{ userId:any }>()
  );

export const myinventorySuccess = createAction(
    '[Market] MYINVENTORY_SUCCESS',
    props<{ myinventory:any, userSell:any }>()
  );

export const myinventoryFail = createAction(
    '[Market] MYINVENTORY_FAIL',
    props<{ error: any }>()
);

export const purchaseInventory = createAction(
  '[Market] PURCHASEINVENTORY',
  props<{ userId:any, inventoryId:any, quantity:any }>()
  );

export const purchaseInventorySuccess = createAction(
    '[Market] PURCHASEINVENTORY_SUCCESS',
    props<{ myinventory:any }>()
  );

export const purchaseInventoryFail = createAction(
    '[Market] PURCHASEINVENTORY_FAIL',
    props<{ error: any }>()
);

export const useItem = createAction(
  '[Market] USEITEM',
  props<{ userId:any, itemId:any }>()
  );

export const useItemSuccess = createAction(
    '[Market] USEITEM_SUCCESS',
    props<{ missions:any }>()
  );

export const useItemFail = createAction(
    '[Market] USEITEM_FAIL',
    props<{ error: any }>()
);

export const STREETCRED = createAction(
  '[Market] STREETCRED',
  props<{ userId:any }>()
  );

export const streetCredSuccess = createAction(
    '[Market] STREETCRED_SUCCESS',
    props<{ streetcred:any }>()
  );

export const streetCredFail = createAction(
    '[Market] STREETCRED_FAIL',
    props<{ error: any }>()
);

export const scoreboard = createAction(
  '[Market] SCOREBOARD',
  props<{ data:any, userId:any }>()
  );

export const scoreboardSuccess = createAction(
  '[Market] SCOREBOARD_SUCCESS',
  props<{ scores:any,userScore:any }>()
);

export const scoreboardFail = createAction(
  '[Market] SCOREBOARD_FAIL',
  props<{ error: any }>()
);

export const myMissionDetails = createAction(
  '[Market] MY_MISSION_DETAILS',
  props<{ onMissions: any, claimable:any }>()
  );

export const myMissionDetailsSuccess = createAction(
  '[Market] MY_MISSION_DETAILS_SUCCESS',
  props<{ onMissions: any, claimable:any }>()
);

export const selectDetails = createAction(
  '[Market] SELECT_DETAILS',
  props<{ data: any }>()
  );

export const selectDetailsSuccess = createAction(
  '[Market] SELECT_DETAILS_SUCCESS',
  props<{ data:any }>()
);

export const selectPack = createAction(
  '[Market] SELECT_PACK',
  props<{ data: any }>()
  );

export const selectPackSuccess = createAction(
  '[Market] SELECT_PACK_SUCCESS',
  props<{ data:any }>()
);

export const burnPass= createAction(
  '[Market] BURNPASS',
  props<{ signature:any, tokens:any[], season:any, userId:any }>()
  );

export const burnPassSuccess = createAction(
  '[Market] BURNPASS_SUCCESS',
  props<{ pass:any }>()
);

export const burnPassFail = createAction(
  '[Market] BURNPASS_FAIL',
  props<{ error: any }>()
);

export const discordData = createAction(
  '[Market] DISCORD_DATA',
  props<{ code:string, userId:any }>()
  );

export const discordDataSuccess = createAction(
    '[Market] DISCORD_DATA_SUCCESS',
    props<{ Discord: any }>()
  );

export const discordDataFail = createAction(
    '[Market] DISCORD_DATA_FAIL',
    props<{ error: Error }>()
);

export const packSignature = createAction(
  '[Market] PACK_SIGNATURE',
  props<{ userId:any, typeP:any, quantity:any }>()
  );

export const packSignatureSuccess = createAction(
    '[Market] PACK_SIGNATURE_SUCCESS',
    props<{ signature: any }>()
  );

export const packSignatureFail = createAction(
    '[Market] PACK_SIGNATURE_FAIL',
    props<{ error: Error }>()
);


export const passSignature = createAction(
  '[Market] PASS_SIGNATURE',
  props<{ userId:any, ids:any[], season:any }>()
  );

export const passSignatureSuccess = createAction(
    '[Market] PASS_SIGNATURE_SUCCESS',
    props<{ signature: any }>()
  );

export const passSignatureFail = createAction(
    '[Market] PASS_SIGNATURE_FAIL',
    props<{ error: Error }>()
);

export const packInteraction = createAction(
  '[Market] PACK_INTERACTION',
  props<{ sig:any, userId:any, typeP:any, quantity:any }>()
  );

export const packInteractionSuccess = createAction(
    '[Market] PACK_INTERACTION_SUCCESS',
    props<{ pack:any }>()
  );

export const packInteractionFail = createAction(
    '[Market] PACK_INTERACTION_FAIL',
    props<{ error: any }>()
);

export const packOpen = createAction(
  '[Market] PACK_OPEN',
  props<{ tokenId:any, userId:any, address:any }>()
  );

export const packOpenSuccess = createAction(
    '[Market] PACK_OPEN_SUCCESS',
    props<{ card:any }>()
  );

export const packOpenFail = createAction(
    '[Market] PACK_OPEN_FAIL',
    props<{ error: Error }>()
);

export const closeOpen = createAction(
  '[Market] CLOSE_OPEN',
  props<{ data:any }>()
  );

export const upgradeNFT = createAction(
  '[Market] UPGRADE_NFT',
  props<{ tokenId:any, userId:any, address:any }>()
  );

export const closeUpgrade = createAction(
    '[Market] CLOSE_UPGRADE',
    props<{ data:any }>()
    );

export const upgradeNFTSuccess = createAction(
    '[Market] UPGRADE_NFT_SUCCESS',
    props<{ card:any }>()
  );

export const upgradeNFTFail = createAction(
    '[Market] UPGRADE_NFT_FAIL',
    props<{ error: Error }>()
);

export const packs = createAction(
  '[Market] PACKS',
  props<{ data:any }>()
  );

export const packsSuccess = createAction(
    '[Market] PACKS_SUCCESS',
    props<{ packs:any }>()
  );

export const packsFail = createAction(
    '[Market] PACKS_FAIL',
    props<{ error: any }>()
);

export const checkApproval = createAction(
  '[Market] CHECK_APPROVAL',
  props<{ data:any }>()
  );

export const checkApprovalSuccess = createAction(
    '[Market] CHECK_APPROVAL_SUCCESS',
    props<{ approval:any }>()
  );

export const checkApprovalFail = createAction(
    '[Market] CHECK_APPROVAL_FAIL',
    props<{ error: any }>()
);

export const allSell = createAction(
  '[Market] ALL_SELL',
  props<{ data:any }>()
  );

export const allSellSuccess = createAction(
    '[Market] ALL_SELL_SUCCESS',
    props<{ allSell:any }>()
  );

export const allSellFail = createAction(
    '[Market] ALL_SELL_FAIL',
    props<{ error: any }>()
);

export const listSell = createAction(
  '[Market] LIST_SELL',
  props<{ userId:any, userItemId:any, price:any }>()
  );

export const listSellSuccess = createAction(
    '[Market] LIST_SELL_SUCCESS',
    props<{ data:any }>()
  );

export const listSellFail = createAction(
    '[Market] LIST_SELL_FAIL',
    props<{ error: any }>()
);

export const cancelSell = createAction(
  '[Market] CANCEL_SELL',
  props<{ userId:any, sell:any }>()
  );

export const cancelSellSuccess = createAction(
    '[Market] CANCEL_SELL_SUCCESS',
    props<{ data:any }>()
  );

export const cancelSellFail = createAction(
    '[Market] CANCEL_SELL_FAIL',
    props<{ error: any }>()
);

export const purchaseSell = createAction(
  '[Market] PURCHASE_SELL',
  props<{ userId:any, userSell:any }>()
  );

export const purchaseSellSuccess = createAction(
    '[Market] PURCHASE_SELL_SUCCESS',
    props<{ data:any }>()
  );

export const purchaseSellFail = createAction(
    '[Market] PURCHASE_SELL_FAIL',
    props<{ error: any }>()
);

export const closeModal = createAction(
  '[Market] CLOSE_MODAL',
  props<{ data:any }>()
  );

export const closeModalSuccess = createAction(
    '[Market] CLOSE_MODAL_SUCCESS',
    props<{ data:any }>()
  );

export const shareprofile = createAction(
    '[Market] SHARE_PROFILE',
    props<{ data:any }>()
);
  
export const shareprofileSuccess = createAction(
      '[Market] SHARE_PROFILE_SUCCESS',
      props<{ data:any }>()
    );

export const mobileMenu = createAction(
      '[Market] MOBILE_MENU',
      props<{ data:any }>()
  );
    
export const mobileMenuSuccess = createAction(
        '[Market] MOBILE_MENU_SUCCESS',
        props<{ data:any }>()
      );

export const opensea = createAction(
        '[Market] OPENSEA',
        props<{ tokenId:any }>()
    );
      
  export const openseaSuccess = createAction(
          '[Market] OPENSEA_SUCCESS',
          props<{ data:any }>()
        );

        export const openseaFail = createAction(
          '[Market] OPENSEA_FAIL',
          props<{ error: any }>()
      );

  

  
